export default [
    {
        path: '/hours',
        name: 'hour-hours',
        component: () => import ('./views/HourIndex'),
        meta: {
            title: 'Horários',
            icon: 'mdi-clock-outline',
            breadcrumbs: [
                { text: 'Lista de horários disponíveis', disabled: true }
            ]
        }
    },
]
